const LogoValid = () => {
  return (
    <svg className="logoValid" xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none">
        <path fillRule="evenodd" d="M27.2762 9.22241c-3.8824 3.29879-7.8827 6.78899-9.9175 11.56939-.3702.8009-.6765 1.6832-.9564 2.4941-1.8477-2.4065-4.9004-3.3501-7.59786-4.4701-1.26526-.5331-.81966.8222-.14686 1.1864C12.0303 21.6741 15.1445 24.8977 17.1102 28c1.4623-6.9604 6.2259-12.7145 10.6995-18.07679.3778-.44551.1895-1.33902-.5335-.7008Z" clipRule="evenodd"/>
        <circle cx="18" cy="18" r="17" stroke="url(#a)" strokeWidth="2"/>
        <defs>
            <linearGradient id="a" x1="18" x2="18" y1="0" y2="36" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="1"/>
            </linearGradient>
        </defs>
    </svg>
  )
}
export default LogoValid;